import { Link } from '@tanstack/react-router';
import { FileQuestion, House } from 'lucide-react';
import { EmptyState } from '@/components/common/EmptyState';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function RouteNotFound() {
  return (
    <EmptyState
      icon={FileQuestion}
      title="This page is not available"
      description="It may have moved, or your access may have changed. Try the dashboard, or ask an administrator."
      fill
      actions={
        <Link to="/" className={cn(buttonVariants({ variant: 'outline', size: 'sm' }), 'gap-1.5')}>
          <House className="size-3.5" />
          Go to dashboard
        </Link>
      }
    />
  );
}
